<template>
  <require from="components/toolbars/clear-filters-toolbar-component"></require>
  <div class="btn-group">
    <clear-filters-toolbar-component query-memory.bind="queryMemory" hint.bind="hint"></clear-filters-toolbar-component>
  </div>
</template>
